export default function Home({ sentinelRef }) {
  return (
    <section className="homepage">
      <h1 className="h1-homepage">Jolanta Hildebrandt-Mazurek</h1>

      <div ref={sentinelRef} className="hero-sentinel" />
    </section>
  );
}
